<script setup>
import {ref} from "vue";

const siteUrl = document.querySelector('meta[name="site-url"]').content;
const props = defineProps({
  isShow: {
    type: Boolean,
    required: true,
  },
  booleanValue: {
    type: Boolean,
    required: true,
  },
  titleText: {
    type: String,
    required: true,
  },
  headerText: {
    type: String,
    default: '',
  },
  switchText: {
    type: String,
    required: true,
  },
  enableText: {
    type: String,
    required: true,
  },
  disableText: {
    type: String,
    required: true,
  }
});
const emits = defineEmits([
  'request-close',
  'request-submit'
]);

// ローカルの真偽値
const localBooleanValue = ref(props.booleanValue);
</script>

<template>
  <div v-if="isShow">
    <div :class="{modModalWindow: true, mdPopUp: true, isShow}">
      <div class="modModalTitleContainer">
        <p class="pFont16 pFontBold">{{headerText === '' ? titleText : headerText}}</p>
        <button
          type="button"
          class="lyHvCnt lyColumn lyW48px lyH48px pFont10 pFontBold"
          @click="emits('request-close')"
        >
      <span class="lyBlock lyW24px"><img
        :src="siteUrl+'images/iconClose.svg'"
        loading="lazy"
        alt="" width="30"
        height="31"
      ></span>
          とじる
        </button>
      </div>
      <div class="modModalBottomWrapper">
        <div class="modModalBottomWrapper">
          <div class="lyPd16">
            <p class="lyMb16 pFont14">{{titleText}}</p>
          </div>
          <div class="lyMtAuto">
            <div class="lyPd16 pBackColorGray4">
              <div class="lyHorizontalBw">
                <slot></slot>
                <label for="switchPublic" class="pSwitch lyVerticalCnt">
                  <input
                    v-model="localBooleanValue"
                    type="checkbox"
                    name="public"
                    id="switchPublic"
                  >
                  <div class="lyOrder1 pSwitchBtn"></div>
                  <p class="lyOrder0 lyMr4 pSwitchTitle pFont12 pFontBold">{{enableText}}</p>
                  <p class="lyOrder2 lyMl4 pSwitchTitle pFont12 pFontBold">{{disableText}}</p>
                </label>
              </div>
            </div>
            <div class="lyHorizontal pBorderTop2pxSolidGray4">
              <p class="lyW50 pBorderRight2pxSolidGray4">
                <button
                  type="button"
                  class="lyW100 lyPt16 lyPb16 pFont14 pFontBold"
                  @click="emits('request-close')"
                >とじる</button>
              </p>
              <p class="lyW50">
                <button
                  type="button"
                  class="lyW100 lyPt16 lyPb16 pFont14 pFontBold pFontGreen"
                  @click="emits('request-submit', localBooleanValue)"
                >設定</button>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      :class="{gbModalBack: true, mdPopUp: true, isShow}"
      @click="emits('request-close')"
    ></div>
  </div>
</template>